import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Icon from '../Icon';

export interface TaskLoaderProps {
  id?: string;
  className?: string;
  statusLabel?: string;
  loadingLabel?: string;
  status?: string;
}

const TaskLoader: React.FC<TaskLoaderProps> = (props: TaskLoaderProps) => {
  const { id, status, className, statusLabel, loadingLabel } = props;

  const [fadeOutClass, setFadeOutClass] = useState('');
  const [showStatusLabel, setShowStatusLabel] = useState(false);

  useEffect(() => {
    if (status) {
      setFadeOutClass('ui-task-loader__fade-out');

      setTimeout(() => {
        setShowStatusLabel(true);
      }, 400);
    }

    return () => {
      setFadeOutClass('');
      setShowStatusLabel(false);
    };
  }, [status]);

  const tskLdrClass = classNames(
    'ui-task-loader',
    {
      'ui-task-loader--failed': status === 'failed',
      'ui-task-loader--success': status === 'success',
    },
    className
  );

  return (
    <div className="ui-task-loader__container">
      <div id={id} className={tskLdrClass}>
        <svg
          className="ui-task-loader__circle_stroke-wrapper"
          viewBox="25 25 50 50"
        >
          <circle
            className="ui-task-loader__circle_stroke"
            cx="50"
            cy="50"
            r="21"
            fill="none"
            strokeMiterlimit="10"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
        {status === 'failed' ? (
          <Icon
            className="ui-task-loader__icon"
            name="exclamation-point"
            size="xx-large"
          />
        ) : (
          <Icon
            className="ui-task-loader__icon"
            name="checkmark"
            size="xx-large"
          />
        )}
        <div className="ui-task-loader__circle_fill" />
      </div>
      {showStatusLabel && (
        <div className="ui-task-loader__status-label">{statusLabel}</div>
      )}
      {!showStatusLabel && (
        <div className={`ui-task-loader__loading-label ${fadeOutClass}`}>
          {loadingLabel}
        </div>
      )}
    </div>
  );
};

export default TaskLoader;
